// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/sbd.proto (package knop.ui.v1.api, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { OccupationsForTrack } from "../model/occupations_for_track_pb.js";
import { BlockedInfrastructures } from "../model/blocked_infrastructures_pb.js";
import { DisplayConfiguration } from "../model/display_configuration_pb.js";
import { TrackGroup } from "../model/trackgroup_pb.js";

/**
 * @generated from message knop.ui.v1.api.TrackOccupationsRequest
 */
export class TrackOccupationsRequest extends Message<TrackOccupationsRequest> {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId = "";

  constructor(data?: PartialMessage<TrackOccupationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.TrackOccupationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrackOccupationsRequest {
    return new TrackOccupationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrackOccupationsRequest {
    return new TrackOccupationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrackOccupationsRequest {
    return new TrackOccupationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TrackOccupationsRequest | PlainMessage<TrackOccupationsRequest> | undefined, b: TrackOccupationsRequest | PlainMessage<TrackOccupationsRequest> | undefined): boolean {
    return proto3.util.equals(TrackOccupationsRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.TrackOccupationsResponse
 */
export class TrackOccupationsResponse extends Message<TrackOccupationsResponse> {
  /**
   * @generated from field: repeated knop.ui.v1.model.OccupationsForTrack track_occupations = 1;
   */
  trackOccupations: OccupationsForTrack[] = [];

  /**
   * @generated from field: repeated knop.ui.v1.model.BlockedInfrastructures blocked_infrastructures = 3;
   */
  blockedInfrastructures: BlockedInfrastructures[] = [];

  /**
   * @generated from field: map<string, knop.ui.v1.model.DisplayConfiguration> display_configuration_by_track_code = 4;
   */
  displayConfigurationByTrackCode: { [key: string]: DisplayConfiguration } = {};

  /**
   * @generated from field: repeated knop.ui.v1.model.TrackGroup track_groups = 5;
   */
  trackGroups: TrackGroup[] = [];

  constructor(data?: PartialMessage<TrackOccupationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.TrackOccupationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "track_occupations", kind: "message", T: OccupationsForTrack, repeated: true },
    { no: 3, name: "blocked_infrastructures", kind: "message", T: BlockedInfrastructures, repeated: true },
    { no: 4, name: "display_configuration_by_track_code", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: DisplayConfiguration} },
    { no: 5, name: "track_groups", kind: "message", T: TrackGroup, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrackOccupationsResponse {
    return new TrackOccupationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrackOccupationsResponse {
    return new TrackOccupationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrackOccupationsResponse {
    return new TrackOccupationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TrackOccupationsResponse | PlainMessage<TrackOccupationsResponse> | undefined, b: TrackOccupationsResponse | PlainMessage<TrackOccupationsResponse> | undefined): boolean {
    return proto3.util.equals(TrackOccupationsResponse, a, b);
  }
}

